import { Permissions, usePermission } from 'src/rbac';

/**
 * May this user add a scheduler announcement? Drives visibility of the announcement
 * IconButton on the therapist scheduling board.
 *
 * Migrated (Segment B) from the legacy
 * `permissionData?.currentPermissions?.includes('Add Scheduler Announcement')` display-name
 * check to the instrumented `Permissions.ADD_SCHEDULER_ANNOUNCEMENT` scopeKey. Note the key
 * remap: the legacy paths.ts key was `ADD_ANNOUNCEMENT`, but its display name is
 * "Add Scheduler Announcement", which equals the catalog display name for scopeKey
 * `ADD_SCHEDULER_ANNOUNCEMENT` (parity-verified in rbac-parity.test.ts). Behavior is preserved;
 * the check now emits RUM telemetry.
 */
export function useAddAnnouncementGate(): boolean {
  return usePermission(Permissions.ADD_SCHEDULER_ANNOUNCEMENT);
}
